import React from "react";

const TestDrive = ({ size = "40", fill = "#BEBEBE" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1025_578)">
        <path
          d="M20 2C10.075 2 2 10.075 2 20C2 29.925 10.075 38 20 38C29.925 38 38 29.925 38 20C38 10.075 29.925 2 20 2ZM20 36.5C10.9 36.5 3.5 29.1 3.5 20C3.5 10.9 10.9 3.5 20 3.5C29.1 3.5 36.5 10.9 36.5 20C36.5 29.1 29.1 36.5 20 36.5Z"
          fill={fill}
        />
        <path
          d="M6.37502 20.125C6.15002 20.095 5.93002 20.17 5.76502 20.32C5.60002 20.475 5.51502 20.6901 5.53002 20.9151C5.96002 27.825 11.255 33.485 18.12 34.375C18.15 34.375 18.185 34.3801 18.215 34.3801C18.405 34.3801 18.59 34.3101 18.725 34.18C18.89 34.0251 18.975 33.81 18.96 33.585C18.53 26.675 13.235 21.015 6.37002 20.125H6.37502ZM7.12002 21.77C12.505 22.87 16.63 27.285 17.375 32.73C11.99 31.63 7.86502 27.215 7.12002 21.77Z"
          fill={fill}
        />
        <path
          d="M34.245 20.27C34.09 20.12 33.87 20.045 33.655 20.06C26.585 20.71 20.94 26.55 20.525 33.64C20.51 33.86 20.595 34.07 20.75 34.225C20.89 34.36 21.08 34.435 21.27 34.435C21.295 34.435 21.315 34.435 21.34 34.435C28.41 33.785 34.055 27.945 34.47 20.855C34.485 20.635 34.4 20.425 34.245 20.27ZM22.11 32.825C22.845 27.18 27.275 22.595 32.89 21.67C32.155 27.315 27.725 31.9 22.11 32.825Z"
          fill={fill}
        />
        <path
          d="M33.475 18.005C33.7 18.005 33.915 17.905 34.055 17.73C34.2 17.555 34.255 17.325 34.21 17.105C34.165 16.87 34.11 16.64 34.05 16.41C32.415 9.99 26.635 5.5 20 5.5C13.365 5.5 7.16503 10.37 5.79503 17.08C5.75003 17.3 5.80503 17.53 5.95003 17.705C6.09003 17.88 6.30503 17.98 6.53003 17.98L33.475 18.005ZM7.48003 16.48C9.03503 10.935 14.16 7 20 7C25.84 7 30.965 10.895 32.525 16.505L7.48503 16.48H7.48003Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1025_578">
          <rect width={size} height={size} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TestDrive;
